<template>
  <div v-if="zkName">
    <div class="studentInfoWrap">
      <div class="studentInfoEnter">
        <div class="input_info">
          <div class="input-info-item info-text">
            <p>学员微信昵称：</p>
            <!-- <dl class="flex-right-input"> -->
            <p class="block-color">{{ studentName || "--" }}</p>
            <!-- </dl> -->
          </div>
          <div class="input-info-item">
            <p>学员跟进咨询师：</p>
            <dl class="flex-right-input">
              <input type="text" v-model="zkName" ref="studentName" readonly class="readOnly" />
            </dl>
          </div>
          <div class="input-info-item">
            <p class="required_input">归属渠道</p>
            <dl class="flex-right-input">
              <el-select v-model="ruleForm.cannalId" filterable ref="mySelect" placeholder="请选择" @focus="focusWidth" style="width: 100%">
                <el-option v-for="item in source" :key="item.cannalId" :label="item.cannalName" :value="item.cannalId" :style="{ width: setOptionWidth }" />
              </el-select>
            </dl>
          </div>
          <div class="input-info-item">
            <p class="required_input">手机号：</p>
            <dl class="flex-right-input">
              <input type="tel" placeholder="请输入" v-model="ruleForm.phone" ref="phone" maxlength="11" @focus="clearInput" />
              <p class="error_text" v-show="isShowError">
                {{ !ruleForm.phone ? "请输入手机号" : !validator(ruleForm.phone) ? "手机号格式错误" : "" }}
              </p>
            </dl>
          </div>
          <div class="input-info-item">
            <p>学员备注：</p>
            <dl class="flex-right-input">
              <textarea placeholder="请输入..." v-model="ruleForm.des" rows="12" maxlength="500" />
            </dl>
          </div>
        </div>
      </div>
      <div :class="showClick ? 'disabled-bg submit_fixed' : 'submit_fixed'">
        <span @click="ensureSubmit">确认提交</span>
      </div>
    </div>
  </div>
</template>

<script>
import { writePhone, queryCannal, querexinfo } from "@/server/api.js";
import { Toast, Notify } from "vant";
import { wxConfig } from "../fastReply/js/config";
import { addressBar } from "@/utils/public";
export default {
  name: "addTel",
  data() {
    return {
      ruleForm: {
        phone: "",
        des: "",
        cannalId: "",
        cannalName: "",
      },
      zsUserId: "",
      zkName: "",
      source: [], // 归属渠道
      isShowError: false,
      externalUserid: "",
      // externalUserid: "wm6lPiDAAA-a-HhaEB0pAX4CRqDmKcnA1",
      userInfo: {},
      setOptionWidth: null,
      showClick: false,
      studentName: "",
      windowurl: window.location.href.split("#")[0] || "http://tm-qw.1000phone.net/addTel",
      jsList: ["getCurExternalContact"],
    };
  },
  watch: {},
  async mounted() {
    if (localStorage.getItem("token")) {
      this.externalUserid = localStorage.getItem("externalUserid");
      this.InitMethod();
    } else {
      addressBar("token", this.windowurl);
    }
  },
  methods: {
    InitMethod() {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.userId = localStorage.getItem("userid");
      this.zsUserid = localStorage.getItem("zsUserId");
      this.zkName = this.userInfo?.name || "";
      if (!this.externalUserid) {
        wxConfig(this.windowurl, this.jsList).then(() => {
          this.hasuserid();
        });
      } else {
        this.canClick();
      }
    },
    async canClick() {
      let res = await querexinfo({
        externalUserId: this.externalUserid,
      });
      if (res.code !== "200") return Toast.fail(res.msg);
      this.studentName = res.data.name;
      if (res.data?.zsAskId && res.data?.zsAskId > 0) {
        this.showClick = true;
        Notify({ type: "danger", message: "学员已被补录", duration: 2000 });
        if (localStorage.getItem("externalUserid")) {
          localStorage.removeItem("externalUserid");
          this.externalUserid = "";
        }
        return;
      } else {
        this.sourceList();
      }
    },
    hasuserid() {
      let that = this;
      wx.invoke("getCurExternalContact", {}, function (res) {
        if (res.userId) {
          that.externalUserid = res.userId;
          that.canClick();
          // that.sourceList();
        }
      });
    },
    async ensureSubmit() {
      if (this.showClick) return;
      if (!this.ruleForm.cannalId) return Toast.fail("请选择归属渠道");
      if (!this.ruleForm.phone || !this.validator(this.ruleForm.phone)) return (this.isShowError = true);
      let params = {
        externalUserid: this.externalUserid,
        userId: this.userId,
        cannalName: this.$refs.mySelect.selected.label,
        ...this.ruleForm,
      };
      //补录
      writePhone(params).then((res) => {
        if (res.code !== "200") return Toast.fail(res.msg);
        Toast.success("补录成功");
        if (localStorage.getItem("externalUserid")) {
          this.externalUserid = "";
          localStorage.removeItem("externalUserid");
          this.$router.push({ name: "Info", params: { refresh: "sure" } });
        } else {
          this.$router.push({
            path: "/telSuccess",
            query: { externalUserid: this.externalUserid },
          });
        }
      });
    },
    // 归属渠道
    sourceList() {
      if (this.showClick) return;
      queryCannal({
        externalUserId: this.externalUserid,
        uid: this.zsUserid,
      }).then((res) => {
        if (res.code !== "200") return Toast.fail(res.msg);
        this.source = res.data;
        if (res.data.length > 0) {
          this.ruleForm.cannalName = res.data[0]?.cannalName || "";
          this.ruleForm.cannalId = res.data[0]?.cannalId.toString() || "";
        }
      });
      // d.sort((a, b) => mixSort(a.cannalName, b.cannalName));
    },
    focusWidth(e) {
      this.setOptionWidth = e.srcElement.offsetWidth + "px";
    },
    validator(val) {
      return /^1(3|4|5|6|7|8|9)\d{9}$/.test(val);
    },
    clearInput() {
      this.isShowError = false;
    },
  },
  destroyed() {
    this.externalUserid = "";
    localStorage.removeItem("externalUserid");
  },
};
</script>

<style scoped lang="less">
.studentInfoWrap {
  min-height: 100vh;
  background-color: #fff;
  padding: 70px 28px 50px;
  .studentInfoEnter {
    .input_info {
      margin-bottom: 30px;
      .info-text {
        display: flex;
        .block-color {
          color: #333;
        }
      }
      .input-info-item {
        margin-bottom: 30px;
        p {
          color: #666666;
          font-size: 28px;
          margin-bottom: 20px;
          &.required_input {
            position: relative;
            padding-left: 19px;
            &::after {
              position: absolute;
              left: 2px;
              top: 6px;
              color: #ff3232;
              content: "*";
            }
          }
        }
        .flex-right-input {
          position: relative;
          input {
            width: 100%;
            padding: 20px 24px;
            font-size: 28px;
            color: #333333;
            border: 1px solid #c4c4c4;
            border-radius: 8px;
            &.readOnly {
              background-color: #f6f6f6;
            }
            &::-webkit-input-placeholder {
              color: #999999;
            }
          }
          /deep/.el-select {
            .el-input__inner {
              height: 80px;
              border-radius: 8px;
              font-size: 28px;
            }

            &::-webkit-input-placeholder {
              color: #999999;
            }
            .el-input__inner {
              border-color: #c4c4c4;
              color: #333333;
            }
          }

          .error_text {
            color: #ff3232;
            padding-top: 4px;
          }
          textarea {
            width: 100%;
            border: 1px solid #c4c4c4;
            resize: none;
            padding: 20px 24px;
            font-size: 28px;
            border-radius: 8px;
          }
        }
      }
    }
  }
  .submit_fixed {
    margin: 0 auto;
    background-color: #277fff;
    width: 500px;
    padding: 20px 0;
    text-align: center;
    color: #ffffff;
    font-size: 32px;
    border-radius: 44px;
    letter-spacing: 1px;
  }
  .disabled-bg {
    background-color: #888;
  }
}
.el-select-dropdown__item {
  height: 60px;
  line-height: 60px;
  font-size: 26px;
}
</style>
